import { Button } from '@/components/ui/button';
import { useLocales } from '@/locales';
import { useNavigate } from 'react-router';
import { links } from '@/data';
import { useState } from 'react';
import { Phone } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

const noop = () => {};

export default function Footer({
  scrollToElement = noop,
  elementRefs = {},
  active = '',
  handleActive = noop,
}) {
  const { translate } = useLocales();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const handleNavigation = path => {
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        scrollToElement(path);
      }, 0);
      return;
    }
    scrollToElement(path);
  };
  return (
    <footer className="footer-nav">
      <div className="footer-nav__header">
        <div className="footerbar__logo" />
        <h3 className="footerbar__title">{translate('INFORMATION_SYSTEM')}</h3>
      </div>
      <div className="footer-nav__navbar">
        <div className="footer-nav__appbar--left">
          <div className="footer-nav__contacts">
            <div className="footer-nav__contacts--details">
              <h5>{translate('Have_you_question')}</h5>
              <h4>
                <a href="tel: +998555064554">+998 (55) 506 45 54</a>
              </h4>
            </div>
            <Button
              variant="ghost"
              size="icon"
              className="footer-nav__contacts--button"
            >
              <Phone className="h-4 w-4" />
            </Button>
          </div>
        </div>
        <div className="row"></div>
        <ul className="footer-nav__navbar--navlink">
          {/* news */}
          <li
            onClick={() => {
              handleActive('news');
              handleNavigation(elementRefs?.newsRef);
            }}
            className={`navlink--item ${active === 'news' ? 'active' : ''}`}
          >
            {translate('News')}
          </li>
          {/* news */}
          {/* Contacts */}
          <li
            onClick={() => {
              handleNavigation(elementRefs?.contactsRef);
              handleActive('contacts');
            }}
            className={`navlink--item ${active === 'contacts' ? 'active' : ''}`}
          >
            {translate('Contacts')}
          </li>
          {/* Contacts */}

          {/* Resource */}
          <DropdownMenu open={open} onOpenChange={setOpen}>
            <DropdownMenuTrigger asChild>
              <li
                style={{ display: 'flex', gap: '5px', alignItems: 'center' }}
                className="navlink--item navlink-resurs"
              >
                {translate('Resource')}
              </li>
            </DropdownMenuTrigger>
            <DropdownMenuContent>
              {links.map((link, index) => (
                <DropdownMenuItem key={index}>
                  <a
                    href={link.url}
                    target="__blank"
                    style={{ textDecoration: 'none', color: '#1a5c7d' }}
                  >
                    {translate(`country_${index + 1}`)}
                  </a>
                </DropdownMenuItem>
              ))}
            </DropdownMenuContent>
          </DropdownMenu>
          {/* Resource */}
          {/* partners */}
          <li
            onClick={() => {
              handleNavigation(elementRefs?.partnersRef);
              handleActive('partners');
            }}
            className={`navlink--item ${active === 'partners' ? 'active' : ''}`}
          >
            {translate('Partners')}
          </li>
          {/* partners */}

          <li
            onClick={() => {
              handleNavigation(elementRefs?.aboutUsRef);
              handleActive('about_us');
            }}
            className={`navlink--item ${active === 'about_us' ? 'active' : ''}`}
          >
            {translate('About_us')}
          </li>
          <li
            onClick={() => {
              handleActive('faq');
              handleNavigation(elementRefs?.faqRef);
            }}
            className={`navlink--item ${active === 'faq' ? 'active' : ''}`}
          >
            {translate('FAQ')}
          </li>
        </ul>
        {/* <div className="copyright"> */}
        {/* Copyright &copy; &nbsp;<span className="highlight">EximERP</span> 2023 */}
        {/* &nbsp;<span className="version">V-1.2.1</span> */}
        {/* </div> */}
      </div>
    </footer>
  );
}
